import React from 'react'
import { useAuth } from '../auth/AuthContext'
import * as Roles from '../utils/Roles'

export interface GrantContentProps {
    roles?: string[]
    permisos?: string[]
    children?: React.ReactNode | (() => React.ReactNode)
}

export default function GrantContent({ roles, permisos, children }: GrantContentProps) {
    const { user, hasPermiso, hasRole } = useAuth()

    if (!user) return null
    const content = <>{typeof children === 'function' ? children() : children}</>
    if (hasRole(Roles.ROLE_ADMIN)) return content

    const allowedByPermisos = Boolean(permisos?.some((permiso) => hasPermiso(permiso)))
    const allowedByRoles = Boolean(roles?.some((role) => hasRole(role)))
    if (!allowedByPermisos && !allowedByRoles) return null
    return content
}
